<template>
  <div class="content" test-id="identikitForm">
    <div class="flex w-full flex-wrap gap-2">
      <div class="w-6">
        <div class="header-form" test-id="identikitHeaderForm">
          <div>
            <Button
              :disabled="numberQuestion === 1"
              icon="pi pi-arrow-left"
              class="p-button-rounded p-button-outlined p-button-secondary mt-1"
              v-tooltip.bottom="'Volver a pregunta anterior'"
              @click="backQuestion()"
              test-id="identikitBackButton"
            />
          </div>
          <div class="flex flex-row gap-0 align-items-center">
            <div>
              <p test-id="identikitQuestion" style="white-space: pre">
                Pregunta {{ numberQuestion }}/13:
              </p>
            </div>
            <div style="max-width: 650px">
              <p class="header-question" test-id="identikitSpecificQuestion">
                <b>{{ questions[numberQuestion - 1] }}</b>
              </p>
            </div>
          </div>
          <div test-id="identikitDivNextButton">
            <Button
              :disabled="numberQuestion === 13"
              icon="pi pi-arrow-right"
              class="p-button-rounded p-button-outlined p-button-secondary mt-1"
              v-tooltip.bottom="'Siguiente pregunta'"
              @click="nextQuestion()"
              test-id="identikitNextButton"
            />
          </div>
        </div>
        <div v-for="item in dropdownAccordionConfig">
          <div v-for="(question, index) in item.questionDropdownData">
            <DropdownAccordion
              :key="index"
              :id="'DropdownAccordion' + index"
              :ref="'DropdownAccordion' + index"
              :numberQuestion="numberQuestion"
              :questionNumber="item.questionNumber"
              :title="question.title"
              :dropdowns="question.dropdowns"
              @updateDropdownData="(field, value) => updateDataToStore(field, value)"
              @closeAllAccordions="(value) => closeAllAccordions(value)"
              :disabledAccordion="!props.isCreate && props.viewTabMode"
            />
          </div>
        </div>

        <div v-for="item in inputsTextConfig">
          <InputTextIdentikit
            v-if="item.questionNumber === numberQuestion"
            :title="item.inputData.title"
            :inputName="item.inputData.inputName"
            @updateInput="(field, value) => updateDataToStore(field, value)"
            :disabledInput="!props.isCreate && props.viewTabMode"
          />
        </div>

        <div class="grid mt-4">
          <div
            class="flex flex-column col-10 ml-1"
            test-id="identikitSpecificDIVDescriptionTextArea"
          >
            <Card
              test-id="identikitSpecificDescription"
              class="w-23rem h-3rem mb-5 bg-gray-100 text-gray-800 shadow-md border border-gray-300 backdrop-blur-sm"
            >
              <template #content>
                <div class="flex justify-content-between">
                  <p class="-mt-3 -ml-1 font-semibold">
                    {{
                      numberQuestion === 11 || numberQuestion === 12
                        ? "Descripción específica"
                        : "Personalizar respuesta"
                    }}
                  </p>
                </div>
              </template>
            </Card>
            <Textarea
              v-model="textAreaContent"
              @input="addAnswer()"
              @keypress="addAnswer()"
              :placeholder="
                numberQuestion === 11 || numberQuestion === 12
                  ? 'Descripción específica'
                  : 'Personalizar respuesta'
              "
              rows="5"
              cols="10"
              class="-mt-4 mr-4 w-23rem"
              test-id="identikitSpecificDescriptionTextArea"
              ref="textAreaContentHTML"
              :disabled="!props.isCreate && props.viewTabMode"
            />
          </div>
        </div>
      </div>
      <div class="w-5">
        <div class="flex flex-column mt-1 ml-2" :style="styleWidth">
          <Card
            class="h-3rem bg-gray-100 text-gray-800 shadow-md border border-gray-300 backdrop-blur-sm"
            test-id="identikitDescriptionsList"
            :style="styleWidth"
          >
            <template #content>
              <p class="-mt-3 font-semibold text-lg -ml-1">Descripción definitiva</p>
            </template>
          </Card>
          <Listbox
            v-model="selectAnswer"
            :options="listAnswers"
            dataKey="answer"
            optionValue="answer"
            optionLabel="answer"
            class="mt-2"
            style="min-height: 35px; max-width: 475px"
            test-id="identikitDescriptionsListbox"
          >
            <template #option="slotProps">
              <div class="flex justify-content-between">
                <span
                  class="mt-2"
                  :test-id="'identikitDescriptionsListboxRespuesta' + parseInt(slotProps.index + 1)"
                  >{{ slotProps.option.answer }}
                </span>
                <div
                  class="flex justify-content-center align-items-center flex-nowrap"
                  :test-id="
                    'identikitDescriptionsListboxDIVButtons' + parseInt(slotProps.index + 1)
                  "
                >
                  <Button
                    v-for="button in buttonsAnswer"
                    :key="button.id"
                    :icon="button.icon"
                    class="p-button-lg p-button-rounded p-button-outlined px-2 py-2 m-1"
                    :class="button.aditionalClasses"
                    :style="{ color: button.color }"
                    v-tooltip.left="button.tooltip"
                    :disabled="button.disabled(slotProps)"
                    @click="button.action($event, slotProps)"
                  />
                </div>
              </div>
            </template>
          </Listbox>
          <ConfirmPopup />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, getCurrentInstance, onMounted } from "vue";
import { useStoreCompat } from "@/composables/useStoreCompat";

import DropdownAccordion from "../IdentikitComponents/DropdownAccordion.vue";
import InputTextIdentikit from "../IdentikitComponents/InputTextIdentikit.vue";

import {
  simpleNullFields,
  emptyArrayFields,
  falseFields,
  listSuffixFields,
  advancedComputedFields,
} from "../IdentikitComponents/data/dataOptions.js";

// Props
const props = defineProps({
  arrId: String,
  isCreate: { type: Boolean, default: true },
  viewTabMode: { type: Boolean, default: false },
});

// Emits
const emit = defineEmits(["updateValue", "validationStatus", "identikitData"]);

// Store & Confirm
const store = useStoreCompat();
const instance = getCurrentInstance();
const $confirm = instance.proxy.$confirm;

// Data refs
const errores = ref({
  identikit: "El identikit debe tener al menos 6 preguntas respondidas",
});
const numberQuestion = ref(1);
const questions = ref([
  "¿RECUERDA CÓMO VESTÍA EL INDIVIDUO?",
  "¿PUEDE DETALLAR EL CABELLO DEL INDIVIDUO?",
  "¿PUEDE DESCRIBIR LA CONTEXTURA FÍSICA DEL INDIVIDUO? ",
  "¿PUEDE INDICAR LA EDAD DEL INDIVIDUO? ",
  "¿ALCANZÓ A VER SI EL INDIVIDUO TENÍA ALGÚN TATUAJE? ",
  "¿PUEDE DETALLAR LOS OJOS DEL INDIVIDUO?",
  "¿PUEDE DETALLAR EL ACENTO DEL INDIVIDUO?",
  "¿VIO SI EL INDIVIDUO TENÍA ALGÚN ACCESORIO PERSONAL? (PIERCING, LENTES..) ",
  "¿CÓMO SE MOVILIZABA EL INDIVIDUO?",
  "¿QUÉ ELEMENTO/S UTILIZÓ EL/LA CONTRAVENTOR/A?",
  "¿ESCUCHÓ O CONOCE EL APODO DEL INDIVIDUO?",
  "¿HAY ALGUNA OTRA DESCRIPCIÓN QUE QUIERA AGREGAR?",
  "¿HUBIERON CÓMPLICES EN EL HECHO?",
]);

const listAnswers = ref([]);
const selectAnswer = ref(null);
const originalAnswersWithoutEdit = ref([]);
const questionsThatWereGivenNextForFirstTime = ref([]);

// Data from identikitOptionsData mixin
const approximateAge = ref(null);
const approximateHeight = ref("");
const textAreaContent = ref("");
const typeOfWeapon = ref({ id: "", nombre: "" });
const stageOfLife = ref({ id: "2", nombre: "Juvenil" });
const fields = ref([
  "orejas",
  "parpados",
  "menton",
  "frente",
  "nariz",
  "bigote",
  "edad",
  "labios",
  "barba",
  "cabello",
  "cejas",
  "ojos",
  "cutis",
  "boca",
  "description",
]);

const headPhrase = ref("");
const sBodyPhrase = ref("");
const iBodyPhrase = ref("");
const feetPhrase = ref("");
const hairPhrase = ref("");
const texturePhrase = ref("");
const agePhrase = ref("");
const mobilityPhrase = ref("");
const weaponPhrase = ref("");
const tatooHeadPhrase = ref({ noArticle: "", withArticle: "" });
const tatooBodyPhrase = ref({ noArticle: "", withArticle: "" });
const tatooArmPhrase = ref({ noArticle: "", withArticle: "" });
const tatooLegPhrase = ref({ noArticle: "", withArticle: "" });
const personalAccessoryPhrase = ref({ noArticle: "", withArticle: "" });

const textAreaContentHTML = ref(null);

// Initialize simple null fields
const simpleNullFieldsRefs = {};
simpleNullFields.forEach((key) => {
  simpleNullFieldsRefs[key] = ref(null);
});

// Initialize empty array fields
const emptyArrayFieldsRefs = {};
emptyArrayFields.forEach((key) => {
  emptyArrayFieldsRefs[key] = ref([]);
});

// Initialize false fields
const falseFieldsRefs = {};
falseFields.forEach((key) => {
  falseFieldsRefs[key] = ref(false);
});

// Helper function to get acusado by arrId
const getAcusadosByPersonaFisicaID = (arrId) => {
  return store.getters["sumario/acusados/getAcusadosByPersonaFisicaID"](arrId);
};

// Computed from store (listSuffixFields)
const storeListFields = computed(() => {
  const fields = {};
  listSuffixFields
    .filter((key) => !emptyArrayFields.includes(`${key}List`))
    .forEach((key) => {
      fields[`${key}List`] = store.state.siis[`${key}List`];
    });
  return fields;
});

// Helper functions for computed
function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function generateAdvancedComputedGetter(item) {
  switch (item.type) {
    case "multiSelect":
      return computed({
        get: () => simpleNullFieldsRefs[item.key].value,
        set: (value) => {
          const multiSelectData = {
            nameMultiSelect: item.multiKey,
            nameString: item.key,
          };
          selectOptionsMultiSelect(value, multiSelectData);
          createPhrase(item.phraseKey);
          updateAnswer();
        },
      });
    case "object":
      return computed({
        get: () => simpleNullFieldsRefs[item.key].value,
        set: (value) => {
          simpleNullFieldsRefs[item.key].value = value?.nombre === undefined ? null : value;
          createPhrase(item.phraseKey);
          updateAnswer();
        },
      });
    default:
      return computed({
        get: () => simpleNullFieldsRefs[item.key].value,
        set: () => {},
      });
  }
}

// Advanced computed fields
const advancedComputedRefs = {};
advancedComputedFields.forEach((item) => {
  advancedComputedRefs[`data${capitalize(item.key)}`] = generateAdvancedComputedGetter(item);
});

const styleWidth = computed(() => {
  const is720 = window.innerWidth <= 1280;
  if (is720) {
    return { width: "300px" };
  }

  return props.viewTabMode ? { width: "475px" } : {};
});

// Special computed properties
const dataVolume = computed({
  get: () => simpleNullFieldsRefs.volume.value,
  set: (value) => {
    if (value.male === undefined) {
      simpleNullFieldsRefs.volume.value = null;
    } else {
      simpleNullFieldsRefs.volume.value = value;
    }
    createPhrase("texture");
    updateAnswer();
  },
});

const dataApproximateHeight = computed({
  get: () => approximateHeight.value,
  set: (value) => {
    approximateHeight.value = value;
    createPhrase("texture");
    updateAnswer();
  },
});

const dataApproximateAge = computed({
  get: () => approximateAge.value,
  set: (value) => {
    approximateAge.value = value;
    createPhrase("age");
    updateAnswer();
  },
});

const dataStageOfLife = computed({
  get: () => stageOfLife.value,
  set: (value) => {
    if (value?.nombre === undefined) {
      stageOfLife.value = { id: "2", nombre: "Juvenil" };
    } else {
      stageOfLife.value = value;
    }
    createPhrase("age");
    updateAnswer();
  },
});

const dataZone = computed({
  get: () => simpleNullFieldsRefs.zone.value,
  set: (value) => {
    const optionWithGenderData = {
      nameString: "zone",
      nameMultiSelect: "zoneMultiSelect",
      genders: ["nombre", "male"],
    };
    selectOptionsMultiSelect(value, optionWithGenderData);
    createPhrase("personalAccessory");
    updateAnswer();
  },
});

const dataMobility = computed({
  get: () => simpleNullFieldsRefs.mobility.value,
  set: (value) => {
    if (value.nombre === undefined) {
      simpleNullFieldsRefs.mobility.value = null;
    } else {
      simpleNullFieldsRefs.mobility.value = value;
    }
    simpleNullFieldsRefs.brand.value = null;
    simpleNullFieldsRefs.mobilityType.value = null;
    simpleNullFieldsRefs.mobilityColor.value = null;
    emptyArrayFieldsRefs.mobilityColorMultiSelect.value = [];
    dataMobilityTypeList.value = value.nombre;
    dataBrandList.value = value.nombre;
    dataMobilityColorList.value = value.nombre;
    createPhrase("mobility");
    updateAnswer();
  },
});

const dataMobilityTypeList = computed({
  get: () => emptyArrayFieldsRefs.mobilityTypeList.value,
  set: (value) => {
    switch (value) {
      case "A pie":
        emptyArrayFieldsRefs.mobilityTypeList.value = [];
        break;
      case "Bicicleta":
        emptyArrayFieldsRefs.mobilityTypeList.value = storeListFields.value.typeBikeList;
        break;
      case "Motocicleta":
        emptyArrayFieldsRefs.mobilityTypeList.value = storeListFields.value.typeMotorcycleList;
        break;
      case "Automovil":
        emptyArrayFieldsRefs.mobilityTypeList.value = storeListFields.value.typeCarList;
        break;
      default:
        emptyArrayFieldsRefs.mobilityTypeList.value = [];
    }
  },
});

const dataBrandList = computed({
  get: () => emptyArrayFieldsRefs.brandList.value,
  set: (value) => {
    switch (value) {
      case "A pie":
        emptyArrayFieldsRefs.brandList.value = [];
        break;
      case "Bicicleta":
        emptyArrayFieldsRefs.brandList.value = storeListFields.value.brandBikeList;
        break;
      case "Motocicleta":
        emptyArrayFieldsRefs.brandList.value = storeListFields.value.brandMotorcycleList;
        break;
      case "Automovil":
        emptyArrayFieldsRefs.brandList.value = storeListFields.value.brandCarList;
        break;
      default:
        emptyArrayFieldsRefs.brandList.value = [];
    }
    updateAnswer();
  },
});

const dataMobilityColorList = computed({
  get: () => emptyArrayFieldsRefs.mobilityColorList.value,
  set: (value) => {
    if (value === "A pie" || value === undefined) {
      emptyArrayFieldsRefs.mobilityColorList.value = [];
    } else {
      emptyArrayFieldsRefs.mobilityColorList.value = storeListFields.value.colorList || [];
    }
    updateAnswer();
  },
});

const dataWeaponElementList = computed({
  get: () => emptyArrayFieldsRefs.weaponElementList.value,
  set: (value) => {
    switch (value) {
      case "Arma blanca":
        emptyArrayFieldsRefs.weaponElementList.value = storeListFields.value.whiteWeaponList;
        break;
      case "Arma de fuego":
        emptyArrayFieldsRefs.weaponElementList.value = storeListFields.value.fireWeaponList;
        break;
      case "Objeto":
        emptyArrayFieldsRefs.weaponElementList.value = storeListFields.value.objectWeaponList;
        break;
      default:
        emptyArrayFieldsRefs.weaponElementList.value = [];
    }
    updateAnswer();
  },
});

const dataWeaponCaliber = computed({
  get: () => simpleNullFieldsRefs.weaponCaliber.value,
  set: (value) => {
    if (value === undefined) {
      simpleNullFieldsRefs.weaponCaliber.value = null;
    } else {
      simpleNullFieldsRefs.weaponCaliber.value = value;
    }
    createPhrase("weapon");
    updateAnswer();
  },
});

const dataTypeOfWeapon = computed({
  get: () => typeOfWeapon.value,
  set: (value) => {
    if (value.nombre === undefined) {
      typeOfWeapon.value = { id: "", nombre: "" };
    } else {
      typeOfWeapon.value = value;
    }
    simpleNullFieldsRefs.weaponElement.value = null;
    simpleNullFieldsRefs.weaponColor.value = null;
    emptyArrayFieldsRefs.weaponColorMultiSelect.value = [];
    emptyArrayFieldsRefs.mobilityColorMultiSelect.value = [];
    simpleNullFieldsRefs.weaponCaliber.value = null;
    dataWeaponElementList.value = value.nombre;
    textAreaContent.value = "";
    updateAnswer();
  },
});

// Special computed refs map
const specialComputedRefs = {
  dataVolume,
  dataApproximateHeight,
  dataApproximateAge,
  dataStageOfLife,
  dataZone,
  dataMobility,
  dataMobilityTypeList,
  dataBrandList,
  dataMobilityColorList,
  dataWeaponElementList,
  dataWeaponCaliber,
  dataTypeOfWeapon,
};

// Computed configurations (from identikitComponentsConfig mixin)
const dropdownAccordionConfig = computed(() => {
  let config = [
    {
      questionNumber: 1,
      questionDropdownData: [
        {
          title: "Cabeza",
          dropdowns: [
            {
              optionTitle: "Prenda",
              optionsList: storeListFields.value.headGarmentList,
              optionsName: "dataHeadGarment",
            },
            {
              optionTitle: "Estilo ",
              optionsList: storeListFields.value.headStyleList,
              optionsName: "dataHeadStyle",
            },
            {
              optionTitle: "Color",
              optionsList: storeListFields.value.headColorList,
              optionsName: "dataHeadColor",
            },
          ],
        },
        {
          title: "Cuerpo Superior",
          dropdowns: [
            {
              optionTitle: "Prenda",
              optionsList: storeListFields.value.sBodyGarmentList,
              optionsName: "dataSBodyGarment",
            },
            {
              optionTitle: "Mangas ",
              optionsList: storeListFields.value.sBodySleevesList,
              optionsName: "dataSBodySleeves",
            },
            {
              optionTitle: "Estilo",
              optionsList: storeListFields.value.sBodyStyleList,
              optionsName: "dataSBodyStyle",
            },
            {
              optionTitle: "Color",
              optionsList: storeListFields.value.sBodyColorList,
              optionsName: "dataSBodyColor",
            },
          ],
        },
        {
          title: "Cuerpo Inferior",
          dropdowns: [
            {
              optionTitle: "Prenda",
              optionsList: storeListFields.value.iBodyGarmentList,
              optionsName: "dataIBodyGarment",
            },
            {
              optionTitle: "Estilo",
              optionsList: storeListFields.value.iBodyStyleList,
              optionsName: "dataIBodyStyle",
            },
            {
              optionTitle: "Color",
              optionsList: storeListFields.value.iBodyColorList,
              optionsName: "dataIBodyColor",
            },
          ],
        },
        {
          title: "Pies",
          dropdowns: [
            {
              optionTitle: "Calzado",
              optionsList: storeListFields.value.feetFootwearList,
              optionsName: "dataFeetFootwear",
            },
            {
              optionTitle: "Estilo",
              optionsList: storeListFields.value.feetStyleList,
              optionsName: "dataFeetStyle",
            },
            {
              optionTitle: "Color",
              optionsList: storeListFields.value.feetColorList,
              optionsName: "dataFeetColor",
            },
          ],
        },
      ],
    },
    {
      questionNumber: 2,
      questionDropdownData: [
        {
          dropdowns: [
            {
              optionTitle: "Longitud",
              optionsList: storeListFields.value.hairLengthList,
              optionsName: "dataHairLength",
            },
            {
              optionTitle: "Tipo ",
              optionsList: storeListFields.value.hairTypeList,
              optionsName: "dataHairType",
            },
            {
              optionTitle: "Color",
              optionsList: storeListFields.value.hairColorList,
              optionsName: "dataHairColor",
            },
          ],
        },
      ],
    },
    {
      questionNumber: 3,
      questionDropdownData: [
        {
          dropdowns: [
            {
              optionTitle: "Sexo",
              optionsList: storeListFields.value.genderList,
              optionsName: "dataGender",
            },
            {
              optionTitle: "Estatura ",
              optionsList: storeListFields.value.heightList,
              optionsName: "dataHeight",
            },
            {
              optionTitle: "Volumen",
              optionsList: storeListFields.value.volumeList,
              optionsName: "dataVolume",
              optionLabel: "male",
            },
          ],
        },
      ],
    },
    {
      questionNumber: 4,
      questionDropdownData: [
        {
          dropdowns: [
            {
              optionTitle: "Edad",
              optionsList: storeListFields.value.stageOfLifeList,
              optionsName: "dataStageOfLife",
            },
          ],
        },
      ],
    },
    {
      questionNumber: 5,
      questionDropdownData: [
        {
          title: "Cabeza",
          dropdowns: [
            {
              optionTitle: "Parte",
              optionsList: storeListFields.value.headPartList,
              optionsName: "dataHeadPart",
            },
            {
              optionTitle: "Zona ",
              optionsList: storeListFields.value.headZoneList,
              optionsName: "dataHeadZone",
            },
            {
              optionTitle: "Tipo",
              optionsList: storeListFields.value.headTypeList,
              optionsName: "dataHeadType",
            },
          ],
        },
        {
          title: "Cuerpo",
          dropdowns: [
            {
              optionTitle: "Parte",
              optionsList: storeListFields.value.bodyPartList,
              optionsName: "dataBodyPart",
            },
            {
              optionTitle: "Zona",
              optionsList: storeListFields.value.bodyZoneList,
              optionsName: "dataBodyZone",
            },
            {
              optionTitle: "Tipo",
              optionsList: storeListFields.value.bodyTypeList,
              optionsName: "dataBodyType",
            },
          ],
        },
        {
          title: "Brazo",
          dropdowns: [
            {
              optionTitle: "Parte",
              optionsList: storeListFields.value.armPartList,
              optionsName: "dataArmPart",
            },
            {
              optionTitle: "Lado",
              optionsList: storeListFields.value.armSideList,
              optionsName: "dataArmSide",
            },
            {
              optionTitle: "Zona",
              optionsList: storeListFields.value.armZoneList,
              optionsName: "dataArmZone",
            },
            {
              optionTitle: "Tipo",
              optionsList: storeListFields.value.armTypeList,
              optionsName: "dataArmType",
            },
          ],
        },
        {
          title: "Pierna",
          dropdowns: [
            {
              optionTitle: "Parte",
              optionsList: storeListFields.value.legPartList,
              optionsName: "dataLegPart",
            },
            {
              optionTitle: "Lado",
              optionsList: storeListFields.value.legSideList,
              optionsName: "dataLegSide",
            },
            {
              optionTitle: "Zona",
              optionsList: storeListFields.value.legZoneList,
              optionsName: "dataLegZone",
            },
            {
              optionTitle: "Tipo",
              optionsList: storeListFields.value.legTypeList,
              optionsName: "dataLegType",
            },
          ],
        },
      ],
    },
    {
      questionNumber: 8,
      questionDropdownData: [
        {
          dropdowns: [
            {
              optionTitle: "Accesorio",
              optionsList: storeListFields.value.accessoryList,
              optionsName: "dataAccessory",
            },
            {
              optionTitle: "Parte",
              optionsList: storeListFields.value.partList,
              optionsName: "dataPart",
            },
            {
              optionTitle: "Zona",
              optionsList: storeListFields.value.zoneList,
              optionsName: "dataZone",
            },
            {
              optionTitle: "Color",
              optionsList: storeListFields.value.colorList,
              optionsName: "dataColor",
            },
          ],
        },
      ],
    },
    {
      questionNumber: 9,
      questionDropdownData: [
        {
          dropdowns: [
            {
              optionTitle: "Movilidad",
              optionsList: storeListFields.value.mobilityList,
              optionsName: "dataMobility",
              updateOtherDropdown: [
                {
                  Marca: {
                    "A pie": [],
                    Bicicleta: storeListFields.value.brandBikeList,
                    Motocicleta: storeListFields.value.brandMotorcycleList,
                    Automovil: storeListFields.value.brandCarList,
                  },
                },
                {
                  Tipo: {
                    "A pie": [],
                    Bicicleta: storeListFields.value.typeBikeList,
                    Motocicleta: storeListFields.value.typeMotorcycleList,
                    Automovil: storeListFields.value.typeCarList,
                  },
                },
                {
                  Color: {
                    "A pie": [],
                    Bicicleta: storeListFields.value.colorList,
                    Motocicleta: storeListFields.value.colorList,
                    Automovil: storeListFields.value.colorList,
                  },
                },
              ],
            },
            {
              optionTitle: "Marca",
              optionsName: "dataMobilityType",
              dynamicOptions: true,
            },
            {
              optionTitle: "Tipo",
              optionsName: "dataMobilityType",
              dynamicOptions: true,
            },
            {
              optionTitle: "Color",
              optionsName: "dataMobilityColor",
              dynamicOptions: true,
            },
          ],
        },
      ],
    },
    {
      questionNumber: 10,
      questionDropdownData: [
        {
          dropdowns: [
            {
              optionTitle: "Tipo",
              optionsList: storeListFields.value.typeOfWeaponList,
              optionsName: "dataTypeOfWeapon",
              updateOtherDropdown: [
                {
                  Elemento: {
                    "Arma blanca": storeListFields.value.whiteWeaponList,
                    "Arma de fuego": storeListFields.value.fireWeaponList,
                    Objeto: storeListFields.value.objectWeaponList,
                  },
                },
              ],
            },
            {
              optionTitle: "Elemento",
              optionsName: "dataWeaponElement",
              dynamicOptions: true,
            },
            {
              optionTitle: "Color",
              optionsList: storeListFields.value.weaponColorList,
              optionsName: "dataWeaponColor",
            },
          ],
        },
      ],
    },
  ];
  return config;
});

const inputsTextConfig = computed(() => {
  const config = [
    {
      questionNumber: 3,
      inputData: {
        title: "Estatura aproximada en cm",
        inputName: "dataApproximateHeight",
      },
    },
    {
      questionNumber: 4,
      inputData: { title: "Edad aproximada", inputName: "dataApproximateAge" },
    },
    {
      questionNumber: 10,
      inputData: { title: "Calibre", inputName: "dataWeaponCaliber" },
    },
  ];
  return config;
});

const buttonsAnswer = computed(() => {
  const buttons = [
    {
      id: 1,
      icon: "pi pi-undo",
      aditionalClasses: "p-button-info",
      color: "#A956F7",
      tooltip: "Deshacer cambio",
      disabled: (slotProps) => !canRevert(slotProps?.option?.questionNumber),
      action: (event, slotProps) => revertAnswer(event, slotProps.option.questionNumber),
    },
    {
      id: 2,
      icon: "pi pi-pencil",
      aditionalClasses: "p-button-info",
      color: "#FFA800",
      tooltip: "Editar respuesta",
      disabled: () => {
        if (props.viewTabMode && props.isCreate === false) {
          return true;
        }
        return false;
      },
      action: (event, slotProps) => editAnswer(event, slotProps.option.questionNumber),
    },
    {
      id: 3,
      icon: "pi pi-trash",
      aditionalClasses: "p-button-danger",
      color: "",
      tooltip: "Eliminar respuesta",
      disabled: () => {
        if (props.viewTabMode && props.isCreate === false) {
          return true;
        }
        return false;
      },
      action: (event, slotProps) => confirmDelete(event, slotProps.option),
    },
  ];
  return buttons;
});

// Methods
const setData = (data) => {
  for (let i of fields.value) {
    if (simpleNullFieldsRefs[i]) {
      simpleNullFieldsRefs[i].value = data[i] || null;
    }
  }
};

const formUpdate = (field, value) => {
  emit("updateValue", field, value);
};

const handleUpdateDescriptionOffender = () => {
  emit("updateValue", "listAnswers", listAnswers.value);
};

const nextQuestion = () => {
  saveForFirstTime();
  addAnswer();
  store.dispatch("sumario/textResetEditsCounter", "Contravener");
  numberQuestion.value = parseInt(numberQuestion.value) + 1;
  emit("updateValue", "numberQuestion", numberQuestion.value);
  putOnTextAreaTheCurrentAnswer();
};

const backQuestion = () => {
  saveForFirstTime();
  addAnswer();
  numberQuestion.value = parseInt(numberQuestion.value) - 1;
  emit("updateValue", "numberQuestion", numberQuestion.value);
  putOnTextAreaTheCurrentAnswer();
};

const saveForFirstTime = () => {
  const theQuestionAlreadyExists = originalAnswersWithoutEdit.value.find(
    (question) => Number(question?.questionNumber) === Number(numberQuestion.value)
  );
  const originalAnswer = listAnswers.value.find(
    (answer) => Number(answer.questionNumber) === Number(numberQuestion.value)
  );
  if (theQuestionAlreadyExists === undefined && originalAnswer !== undefined) {
    originalAnswersWithoutEdit.value.push(originalAnswer);
  }
};

const putOnTextAreaTheCurrentAnswer = () => {
  const currentAnswer = listAnswers.value.find(
    (answer) => Number(answer.questionNumber) === Number(numberQuestion.value)
  );
  if (currentAnswer?.answerToTextAreaContent === undefined) {
    textAreaContent.value = "";
  } else {
    textAreaContent.value = currentAnswer?.answerToTextAreaContent;
  }
};

const updateDataToStore = (field, value) => {
  // Access computed or ref dynamically
  if (advancedComputedRefs[field]) {
    advancedComputedRefs[field].value = value;
  } else if (specialComputedRefs[field]) {
    specialComputedRefs[field].value = value;
  } else if (simpleNullFieldsRefs[field]) {
    simpleNullFieldsRefs[field].value = value;
  } else if (emptyArrayFieldsRefs[field]) {
    emptyArrayFieldsRefs[field].value = value;
  } else if (falseFieldsRefs[field]) {
    falseFieldsRefs[field].value = value;
  }
};

const emitIdentikitData = () => {
  const formattedData = listAnswers.value.map((a) => ({
    pregunta: a.question,
    respuesta: a.answer,
  }));
  emit("identikitData", formattedData);
};

const closeAllAccordions = (exception) => {
  if (!instance) return;
  const refs = instance.refs;
  for (let refProp in refs) {
    if (refProp.includes("DropdownAccordion") && refProp !== exception) {
      const refArray = refs[refProp];
      if (Array.isArray(refArray)) {
        for (let i = 0; i < refArray.length; i++) {
          refArray[i].show = false;
        }
      }
    }
  }
};

// Methods from identikitProcessingAnswersFunctions
const addAnswer = () => {
  if (validateCharactersAmountLimit()) return;
  if (textAreaContent.value === "") return;
  if (!props.isCreate && props.viewTabMode) return;
  const theAnswerAlreadyExists = listAnswers.value.find(
    (answer) => Number(answer.questionNumber) === Number(numberQuestion.value)
  );
  theAnswerAlreadyExists === undefined ? addANewAnswer() : updateAOldAnswer(theAnswerAlreadyExists);
  handleUpdateDescriptionOffender();
  emitIdentikitData();
};

const validateCharactersAmountLimit = () => {
  let exceded = false;
  if (
    textAreaContent.value.length > 100 &&
    (numberQuestion.value === 7 ||
      numberQuestion.value === 11 ||
      numberQuestion.value === 12 ||
      numberQuestion.value === 13)
  ) {
    exceded = true;
  }
  return exceded;
};

const addANewAnswer = () => {
  listAnswers.value.push({
    question: questions.value[numberQuestion.value - 1],
    questionNumber: Number(numberQuestion.value),
    answer: "Respuesta P." + numberQuestion.value + ": " + textAreaContent.value,
    answerToTextAreaContent: textAreaContent.value,
  });
};

const updateAOldAnswer = (theAnswerAlreadyExists) => {
  let indexQuestion = listAnswers.value.indexOf(theAnswerAlreadyExists);
  listAnswers.value.splice(indexQuestion, 1, {
    question: questions.value[numberQuestion.value - 1],
    questionNumber: Number(numberQuestion.value),
    answer: "Respuesta P." + numberQuestion.value + ": " + textAreaContent.value,
    answerToTextAreaContent: textAreaContent.value,
  });
};

const fillTextAreaContent = () => {
  textAreaContent.value = "";
  const generators = {
    1: generateClothingDescription,
    2: generateHairDescription,
    3: generateTextureDescription,
    4: generateAgeDescription,
    5: generateTattooDescription,
    8: generateAccessoryDescription,
    9: generateMobilityDescription,
    10: generateWeaponDescription,
  };
  const generator = generators[numberQuestion.value];
  if (generator) {
    textAreaContent.value = generator();
  }
  sanitizeEmptyTextContent();
};

const sanitizeEmptyTextContent = () => {
  const placeholders = ["Vestía ", "Tenía cabello ", "Portaba "];
  if (placeholders.includes(textAreaContent.value)) {
    textAreaContent.value = "";
  }
};

const generateClothingDescription = () => {
  const parts = [
    headPhrase.value && headPhrase.value + ",",
    sBodyPhrase.value && sBodyPhrase.value + ",",
    iBodyPhrase.value && iBodyPhrase.value + ",",
    feetPhrase.value || "",
  ].filter(Boolean);
  return "Vestía " + parts.join(" ");
};

const generateHairDescription = () => {
  return hairPhrase.value ? "Tenía cabello " + hairPhrase.value + " " : "";
};

const generateTextureDescription = () => {
  return texturePhrase.value ? "Una persona " + texturePhrase.value + " " : "";
};

const generateAgeDescription = () => {
  return agePhrase.value ? "Era " + agePhrase.value + " " : "";
};

const generateTattooDescription = () => {
  const phrases = getTattooPhrases();
  if (phrases.length === 0) return "";
  const { withArticle } = phrases[0];
  const isFeminine = withArticle?.charAt(3) === "a";
  let result = isFeminine ? "Tatuada " : "Tatuado ";
  result += withArticle + " ";
  for (let i = 1; i < phrases.length; i++) {
    result += phrases[i].noArticle + " ";
  }
  return result.trim();
};

const getTattooPhrases = () => {
  const keys = ["Head", "Body", "Arm", "Leg"];
  return keys
    .map((k) => {
      const phraseRef = eval(`tatoo${k}Phrase`).value;
      const withArticle = phraseRef?.withArticle;
      const noArticle = phraseRef?.noArticle;
      if (withArticle || noArticle) {
        return {
          withArticle: withArticle ? withArticle + "," : "",
          noArticle: noArticle ? noArticle + "," : "",
        };
      }
      return null;
    })
    .filter(Boolean);
};

const generateAccessoryDescription = () => {
  return personalAccessoryPhrase.value ? "Portaba " + personalAccessoryPhrase.value + " " : "";
};

const generateMobilityDescription = () => {
  return mobilityPhrase.value ? "Se trasladaba " + mobilityPhrase.value + " " : "";
};

const generateWeaponDescription = () => {
  return weaponPhrase.value || "";
};

const createPhrase = (phraseType) => {
  const generators = {
    1: generatePhraseForQuestion1,
    2: generatePhraseForQuestion2,
    3: generatePhraseForQuestion3,
    4: generatePhraseForQuestion4,
    5: generatePhraseForQuestion5,
    8: generatePhraseForQuestion8,
    9: generatePhraseForQuestion9,
    10: generatePhraseForQuestion10,
  };
  if (generators[numberQuestion.value]) {
    generators[numberQuestion.value](phraseType);
    fillTextAreaContent();
  }
};

const generatePhraseForQuestion1 = (phraseType) => {
  const garmentObj = simpleNullFieldsRefs[phraseType + "Garment"].value;
  const sleevesObj = simpleNullFieldsRefs[phraseType + "Sleeves"]?.value;
  const footwearObj = simpleNullFieldsRefs[phraseType + "Footwear"]?.value;
  const styleObj = simpleNullFieldsRefs[phraseType + "Style"].value;
  const colorStr = simpleNullFieldsRefs[phraseType + "Color"].value;
  const garment = garmentObj ? garmentObj.article + " " + garmentObj.nombre.toLowerCase() : "";
  const sleeves = sleevesObj ? sleevesObj.nombre.toLowerCase() : "";
  const footwear = footwearObj ? footwearObj.article + " " + footwearObj.nombre.toLowerCase() : "";
  const style = styleObj ? styleObj.nombre.toLowerCase() : "";
  const color = colorStr ? "de color " + colorStr.toLowerCase().replaceAll("-", "") : "";
  const parts = [garment, sleeves, footwear, style, color].filter(Boolean);
  eval(`${phraseType}Phrase`).value = parts.join(" ");
};

const generatePhraseForQuestion2 = (phraseType) => {
  const length = simpleNullFieldsRefs[phraseType + "Length"].value?.nombre.toLowerCase() || "";
  const color = simpleNullFieldsRefs[phraseType + "Color"].value
    ? "de color " +
      simpleNullFieldsRefs[phraseType + "Color"].value.toLowerCase().replaceAll("-", "")
    : "";
  const type = simpleNullFieldsRefs[phraseType + "Type"].value?.nombre.toLowerCase() || "";
  const parts = [length, type, color].filter(Boolean);
  eval(`${phraseType}Phrase`).value = parts.join(" ");
};

const generatePhraseForQuestion3 = (phraseType) => {
  const gender = simpleNullFieldsRefs.gender.value?.nombre
    ? "de sexo " + simpleNullFieldsRefs.gender.value.nombre.toLowerCase()
    : "";
  const height = simpleNullFieldsRefs.height.value?.nombre
    ? "de estatura " + simpleNullFieldsRefs.height.value.nombre.toLowerCase() + ","
    : "";
  const volume = simpleNullFieldsRefs.volume.value
    ? simpleNullFieldsRefs.gender.value?.nombre === "Masculino"
      ? " " + simpleNullFieldsRefs.volume.value.male.toLowerCase() + ","
      : " " + simpleNullFieldsRefs.volume.value.femenine.toLowerCase() + ","
    : "";
  const approxHeight = approximateHeight.value
    ? "estatura aproximada de " + approximateHeight.value + " cm"
    : "";
  const parts = [gender, height, volume, approxHeight].filter(Boolean);
  eval(`${phraseType}Phrase`).value = parts.join(" ");
};

const generatePhraseForQuestion4 = (phraseType) => {
  const stageOfLifeValue = stageOfLife.value?.nombre
    ? "un " + stageOfLife.value.nombre.toLowerCase()
    : "";
  const approximateAgeValue = approximateAge.value
    ? "de " + approximateAge.value + " años aproximadamente"
    : "";
  const parts = [stageOfLifeValue, approximateAgeValue].filter(Boolean);
  eval(`${phraseType}Phrase`).value = parts.join(" ");
};

const generatePhraseForQuestion5 = (phraseType) => {
  const phrase = "tatoo" + phraseType.charAt(0).toUpperCase() + phraseType.slice(1) + "Phrase";
  eval(phrase).value = { noArticle: "", withArticle: "" };

  const part = simpleNullFieldsRefs[phraseType + "Part"].value;
  const side = simpleNullFieldsRefs[phraseType + "Side"]?.value;
  const zone = simpleNullFieldsRefs[phraseType + "Zone"]?.value;
  const type = simpleNullFieldsRefs[phraseType + "Type"]?.value;

  const partStr = part ? " en " + part.article.toLowerCase() + " " + part.nombre.toLowerCase() : "";
  const sideStr = side
    ? part?.article === "la"
      ? side.nombre.toLowerCase() + " "
      : side.male.toLowerCase() + " "
    : "";
  const zoneStr = zone ? "en la zona " + zone.toLowerCase().replaceAll("-", "") : "";
  const typeStr = type ? " " + type.article.toLowerCase() + " " + type.nombre.toLowerCase() : "";
  const typeNoArticle = type ? "otro de tipo " + type.nombre.toLowerCase() : "";

  const withArticle = [typeStr, partStr, sideStr, zoneStr].filter(Boolean).join(" ");
  const noArticle = [typeNoArticle, partStr, sideStr, zoneStr].filter(Boolean).join(" ");

  eval(phrase).value.withArticle = withArticle;
  eval(phrase).value.noArticle = noArticle;
};

const generatePhraseForQuestion8 = (phraseType) => {
  const accessory =
    simpleNullFieldsRefs.accessory.value?.article +
      " " +
      simpleNullFieldsRefs.accessory.value?.nombre.toLowerCase() || "";
  const part = simpleNullFieldsRefs.part.value?.nombre
    ? "en su " + simpleNullFieldsRefs.part.value.nombre.toLowerCase()
    : "";
  const zone = simpleNullFieldsRefs.zone.value
    ? !simpleNullFieldsRefs.part.value || simpleNullFieldsRefs.part.value.gender === "femenine"
      ? simpleNullFieldsRefs.zone.value.nombre.toLowerCase().replaceAll("-", "")
      : simpleNullFieldsRefs.zone.value.male.toLowerCase().replaceAll("-", "")
    : "";
  const color = simpleNullFieldsRefs.color.value
    ? "de color " + simpleNullFieldsRefs.color.value.toLowerCase().replaceAll("-", "")
    : "";
  const parts = [accessory, part, zone, color].filter(Boolean);
  eval(`${phraseType}Phrase`).value = parts.join(" ");
};

const generatePhraseForQuestion9 = (phraseType) => {
  const mobility =
    simpleNullFieldsRefs.mobility.value?.article +
      " " +
      simpleNullFieldsRefs.mobility.value?.nombre.toLowerCase() || "";
  const mobilityTypeValue = simpleNullFieldsRefs.mobilityType.value?.nombre.toLowerCase() || "";
  const brandValue = simpleNullFieldsRefs.brand.value?.nombre
    ? "marca " + simpleNullFieldsRefs.brand.value.nombre
    : "";
  const mobilityColorValue = simpleNullFieldsRefs.mobilityColor.value
    ? "de color " + simpleNullFieldsRefs.mobilityColor.value.toLowerCase().replaceAll("-", "")
    : "";
  const parts = [mobility, mobilityTypeValue, brandValue, mobilityColorValue].filter(Boolean);
  eval(`${phraseType}Phrase`).value = parts.join(" ");
};

const generatePhraseForQuestion10 = (phraseType) => {
  const weaponElement =
    simpleNullFieldsRefs.weaponElement.value?.article +
      " " +
      simpleNullFieldsRefs.weaponElement.value?.nombre.toLowerCase() || "";
  const weaponCaliberValue = simpleNullFieldsRefs.weaponCaliber.value
    ? "de calibre " + simpleNullFieldsRefs.weaponCaliber.value + " mm"
    : "";
  const weaponColorValue = simpleNullFieldsRefs.weaponColor.value
    ? "de color " + simpleNullFieldsRefs.weaponColor.value.toLowerCase().replaceAll("-", "")
    : "";
  const parts = [weaponElement, weaponCaliberValue, weaponColorValue].filter(Boolean);
  eval(`${phraseType}Phrase`).value = parts.join(" ");
};

const selectOptionsMultiSelect = (value, multiSelectData) => {
  if (emptyArrayFieldsRefs[multiSelectData.nameMultiSelect].value.length === 0) {
    emptyArrayFieldsRefs[multiSelectData.nameMultiSelect].value.push(
      multiSelectData.genders ? value : value.nombre
    );
    simpleNullFieldsRefs[multiSelectData.nameString].value =
      emptyArrayFieldsRefs[multiSelectData.nameMultiSelect].value[0];
    return;
  }
  if (emptyArrayFieldsRefs[multiSelectData.nameMultiSelect].value.length > 0) {
    addOrRemoveAOption(value, multiSelectData);
  }
};

const addOrRemoveAOption = (value, multiSelectData) => {
  const indexOption = verifyIfTheOptionAlreadyExists(value, multiSelectData);
  if (indexOption === false) {
    emptyArrayFieldsRefs[multiSelectData.nameMultiSelect].value[indexOption] === undefined
      ? emptyArrayFieldsRefs[multiSelectData.nameMultiSelect].value.push(value.nombre)
      : (emptyArrayFieldsRefs[multiSelectData.nameMultiSelect].value[indexOption] = value.nombre);
    createString(multiSelectData);
  } else {
    emptyArrayFieldsRefs[multiSelectData.nameMultiSelect].value.splice(indexOption, 1);
    emptyArrayFieldsRefs[multiSelectData.nameMultiSelect].value[0] === undefined
      ? (simpleNullFieldsRefs[multiSelectData.nameString].value = null)
      : createString(multiSelectData);
  }
};

const verifyIfTheOptionAlreadyExists = (value, multiSelectData) => {
  let alreadyExists;
  if (multiSelectData.genders) {
    alreadyExists = emptyArrayFieldsRefs[multiSelectData.nameMultiSelect].value.find(
      (option) =>
        option === value[multiSelectData.genders[0]] ||
        option === value[multiSelectData.genders[1]] ||
        option[multiSelectData.genders[0]] === value[multiSelectData.genders[0]] ||
        option[multiSelectData.genders[1]] === value[multiSelectData.genders[1]]
    );
  } else {
    alreadyExists = emptyArrayFieldsRefs[multiSelectData.nameMultiSelect].value.find(
      (option) => option === value.nombre
    );
  }
  let indexOption =
    emptyArrayFieldsRefs[multiSelectData.nameMultiSelect].value.indexOf(alreadyExists);
  return alreadyExists === undefined ? false : indexOption;
};

const createString = (multiSelectData) => {
  if (multiSelectData.genders) {
    makeStringWithGender(multiSelectData);
  } else {
    makeStringWithoutGender(multiSelectData.nameString, multiSelectData.nameMultiSelect);
  }
};

const makeStringWithGender = ({ genders, nameMultiSelect, nameString }) => {
  simpleNullFieldsRefs[nameString].value = {
    [genders[0]]: "",
    [genders[1]]: "",
  };
  let optionOfList;
  let indexOption;
  let trueOption;
  let i = 0;
  emptyArrayFieldsRefs[nameMultiSelect].value.map((option) => {
    trueOption = typeof option === "object" ? option[genders[0]] : option;
    optionOfList = simpleNullFieldsRefs[nameString + "List"]?.value?.find(
      (element) => element[genders[0]] === trueOption
    );
    if (!optionOfList) return;
    indexOption = simpleNullFieldsRefs[nameString + "List"].value.indexOf(optionOfList);
    if (i === 0) {
      simpleNullFieldsRefs[nameString].value[genders[0]] =
        simpleNullFieldsRefs[nameString + "List"].value[indexOption][genders[0]];
      simpleNullFieldsRefs[nameString].value[genders[1]] =
        simpleNullFieldsRefs[nameString + "List"].value[indexOption][genders[1]];
    } else {
      simpleNullFieldsRefs[nameString].value[genders[0]] =
        simpleNullFieldsRefs[nameString].value[genders[0]] +
        " - " +
        simpleNullFieldsRefs[nameString + "List"].value[indexOption][genders[0]];
      simpleNullFieldsRefs[nameString].value[genders[1]] =
        simpleNullFieldsRefs[nameString].value[genders[1]] +
        " - " +
        simpleNullFieldsRefs[nameString + "List"].value[indexOption][genders[1]];
    }
    i++;
  });
};

const makeStringWithoutGender = (nameString, nameMultiSelect) => {
  simpleNullFieldsRefs[nameString].value = "";
  let i = 0;
  emptyArrayFieldsRefs[nameMultiSelect].value.map((option) => {
    if (i === 0) {
      simpleNullFieldsRefs[nameString].value = option;
    } else {
      simpleNullFieldsRefs[nameString].value =
        simpleNullFieldsRefs[nameString].value + " - " + option;
    }
    i++;
  });
};

const updateListAnwserWithStore = () => {
  if (!props.arrId) {
    listAnswers.value = [];
    return;
  }

  let offender = getAcusadosByPersonaFisicaID(props.arrId);

  if (offender === undefined) {
    listAnswers.value = [];
  } else {
    listAnswers.value = [...offender.Identikit];
    listAnswers.value = listAnswers.value.map((obj) =>
      Object.fromEntries(
        Object.entries(obj).map(([k, v]) => [
          k,
          k === "questionNumber" && !isNaN(Number(v)) ? Number(v) : v,
        ])
      )
    );
  }
};

const deleteAnswer = (question) => {
  let indexQuestion = listAnswers.value.indexOf(question);
  listAnswers.value.splice(indexQuestion, 1);
  handleUpdateDescriptionOffender();
  textAreaContent.value = "";
};

const canRevert = (questionNumber) => {
  let originalAnswer = originalAnswersWithoutEdit.value.find(
    (answer) => Number(answer?.questionNumber) === Number(questionNumber)
  );
  originalAnswer = originalAnswer?.answer;
  let answerUpdated = listAnswers.value.find(
    (answer) => Number(answer.questionNumber) === Number(questionNumber)
  );
  answerUpdated = answerUpdated?.answer;
  return !!originalAnswer && originalAnswer.trim() !== answerUpdated?.trim();
};

const revertAnswer = (event, questionNumber) => {
  $confirm.require({
    target: event.currentTarget,
    message: "¿Está seguro que quiere restablecer la descripción?",
    icon: "pi pi-question-circle",
    acceptClass: "p-button-danger",
    acceptLabel: "Sí",
    rejectLabel: "No",
    accept: () => {
      numberQuestion.value = Number(questionNumber);
      let originalAnswer = originalAnswersWithoutEdit.value.find(
        (answer) => Number(answer.questionNumber) === Number(questionNumber)
      );
      originalAnswer = originalAnswer?.answer;
      textAreaContent.value = originalAnswer.split(":")[1].trim();
      updateAnswer();
    },
    reject: () => {},
  });
};

const editAnswer = (event, question) => {
  $confirm.require({
    target: event.currentTarget,
    message: "¿Está seguro que quiere editar la descripción?",
    icon: "pi pi-question-circle",
    acceptClass: "p-button-danger",
    acceptLabel: "Sí",
    rejectLabel: "No",
    accept: () => {
      saveForFirstTime();
      let answerToEdit = listAnswers.value.filter(
        (answer) => Number(answer.questionNumber) === Number(question)
      );
      numberQuestion.value = Number(question);
      answerToEdit = answerToEdit[0].answer.replace(`Respuesta P.${question}: `, "");
      textAreaContent.value = answerToEdit;
      textAreaContentHTML.value?.$el?.focus();
      window.scrollTo(0, 0);
    },
    reject: () => {},
  });
};

const confirmDelete = (event, question) => {
  $confirm.require({
    target: event.currentTarget,
    message: "¿Está seguro que quiere eliminar la descripción?",
    icon: "pi pi-question-circle",
    acceptClass: "p-button-danger",
    acceptLabel: "Sí",
    rejectLabel: "No",
    accept: () => {
      try {
        deleteAnswer(question);
      } catch (error) {
        console.error("Error al eliminar el archivo:", error);
      }
    },
    reject: () => {},
  });
};

const updateAnswer = () => {
  addAnswer();
  store.dispatch("sumario/textResetEditsCounter", "Contravener");
  emit("updateValue", "numberQuestion", numberQuestion.value);
};

onMounted(() => {
  if (!props.viewTabMode) updateListAnwserWithStore();
});

// Watcher para cuando cambie el arrId (al cambiar de acusado)
watch(
  () => props.arrId,
  (newArrId, oldArrId) => {
    if (!props.viewTabMode) updateListAnwserWithStore();
  }
);

defineExpose({
  setData,
  formUpdate,
  addAnswer,
  nextQuestion,
  deleteAnswer,
  canRevert,
  emitIdentikitData,
  validateCharactersAmountLimit,
  backQuestion,

  listAnswers,
  numberQuestion,
  simpleNullFieldsRefs,
  textAreaContent,
});
</script>

<style scoped>
.content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}
div.card {
  width: 100%;
}
.map {
  display: block;
  margin-top: 10px;
  height: 60vh;
  width: 50vw;
}
.title {
  padding-top: 5px;
  padding-bottom: 0px;
  font-size: 1rem;
}
.title-toolbar {
  display: flex;
  justify-content: space-between;
}
.search > input {
  margin-right: 10px;
}
.forms > div,
.labeled,
.inputType {
  display: flex;
  flex-wrap: wrap;
}
.inputType label {
  display: none;
}
.forms > div,
.labeled {
  flex-direction: column;
}
.forms > div.actions {
  flex-direction: row-reverse;
  padding-right: 20px;
}
.forms > div .input {
  min-width: 20vw;
  margin-top: 10px;
  margin-bottom: 20px;
  margin-right: 20px;
}
div.flex-inline {
  display: flex;
  flex-wrap: wrap;
}
.minus10 {
  margin-top: -5px;
}
.header-form {
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #969ca3;
  color: #969ca3;
  padding: 0 4px 0 4px;
}
.header-question {
  margin-left: 10px;
  color: black;
}
.description-content {
  margin-top: 2rem;
}
.input {
  max-width: 13rem;
}
.description-autocomplete {
  margin-left: 30px;
  max-width: 150px;
}
.checkbox-container {
  width: 120px;
  margin-left: 8px;
}
@media (min-width: 1362px) {
  .add-button {
    height: 40px;
    width: 150px;
    margin-top: 36px;
  }
}
@media (max-width: 1362px) {
  .add-button {
    height: 40px;
    width: 150px;
    margin: 15px auto auto 15px;
  }
}
.autocomple-size {
  width: 183px;
  min-width: 183px;
  margin-left: 5px;
  margin-top: -5px;
}
.autocomple-size-question3 {
  width: 220px;
  min-width: 183px;
  margin-left: 5px;
  margin-top: -5px;
}
.autocomple-size-multiSelect {
  width: 220px;
  min-width: 183px;
  margin-left: 5px;
  margin-top: -5px;
}
.pseudoTextarea {
  margin-top: 0.6rem;
  width: 97%;
  min-height: 80px;
  max-height: 180px;
  border: 1px solid #d5dadf;
}
.pseudoTextarea-content {
  margin: 10px 5px 10px 10px;
}
.slider-mt {
  margin-top: -25px;
}
.inputText-size {
  width: 183px;
  min-width: 183px;
  margin-left: 5px;
  margin-right: 40px;
  margin-top: -5px;
}
.chevron-color {
  color: #7d858c;
}
.dropdown-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
}
.dropdown-question {
  width: 100%;
  margin-bottom: 20px;
}
</style>
